var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.tag, _vm._b({
    tag: "component",
    staticClass: "button",
    class: _vm.classes,
    attrs: {
      "tabindex": _vm.loading ? -1 : 0
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, 'component', _vm.mergedAttrs, false), [_vm.$slots.icon ? _c('span', {
    staticClass: "button__icon-wrapper"
  }, [_vm._t("icon")], 2) : _vm._e(), _vm.hasText ? _c('span', {
    staticClass: "button__text"
  }, [_vm._t("default")], 2) : _vm._e(), _vm.loading ? _c('span', {
    staticClass: "button__loader-wrapper"
  }, [_c('a-progress-circular', {
    staticClass: "button__loader",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }